"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeeksDropDown = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const react_redux_1 = require("react-redux");
const account_1 = require("../../../../base/account");
const WEEKS_DROP_LIST = [
    {
        id: '0',
        title: 'common.select',
    },
    { id: '1', title: '1주차' },
    { id: '2', title: '2주차' },
    { id: '3', title: '3주차' },
    { id: '4', title: '4주차' },
    { id: '5', title: '5주차' },
];
exports.WeeksDropDown = react_1.default.memo(({ isDisable = false, defaultWeek, handlerChange, isHome = false, }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const [weeks, setWeeks] = react_1.default.useState(isHome || !isTeacher ? { id: '1', title: '1주차' } : { id: '0', title: 'common.select' });
    const list = react_1.default.useMemo(() => (isHome || !isTeacher ? WEEKS_DROP_LIST.slice(1, 6) : WEEKS_DROP_LIST), [isHome, isTeacher]);
    react_1.default.useEffect(() => {
        setWeeks(isHome || !isTeacher
            ? { id: '1', title: '1주차' }
            : { id: '0', title: 'common.select' });
    }, [isHome, isTeacher]);
    react_1.default.useEffect(() => {
        if (defaultWeek) {
            setWeeks(list.find(item => item.id == defaultWeek));
        }
    }, [defaultWeek]);
    react_1.default.useEffect(() => {
        weeks?.id && handlerChange(weeks?.id);
    }, [weeks]);
    return (react_1.default.createElement(common_1.DropDown, { className: `${isMobile && isHome ? 'dropdown-mobile-small' : 'dropdown-live'} ${isMobile && 'weeks-dropdown'}`, isDisable: isDisable, list: list, value: weeks, styles: {
            dropWrap: {
                width: isMobile ? '100%' : '200px',
            },
            itemWrap: {
                top: isMobile && !isHome && '108px',
            },
        }, setDropValue: setWeeks }));
});
